export const statusList = [
  'Active',
  'Inactive',
  'In Review',
  'In Negotiation',
  'Prospect',
];

export const statesList = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'GU', label: 'Guam' },
  { value: 'MP', label: 'Northern Mariana Islands' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'UM', label: 'United States Minor Outlying Islands' },
  { value: 'VI', label: 'Virgin Islands, U.S.' },
];

const stateLabelByValue: Record<string, string> = Object.fromEntries(
  statesList.map((s) => [s.value, s.label]),
);

export const getStateLabel = (value?: string | null): string =>
  (value && stateLabelByValue[value]) || value || '';

export const agencyTypeList = ['Agency', 'Management', 'Independent'];

export const genderList = [
  'Female',
  'Male',
  'Non-Binary',
  'Other',
  'Prefer not to say',
];

export const expertGenderFilterList = genderList;

export const BRIEF_GENDER_NO_PREFERENCE = 'No Preference';

export const projectBriefGenderList = [
  'Female',
  'Male',
  'Non-Binary',
  'Other',
  BRIEF_GENDER_NO_PREFERENCE,
];

export const pronounsList = [
  'She/Her',
  'He/Him',
  'They/Them',
  'Prefer not to say',
];

export const ethnicityList = [
  'American Indian or Alaska Native',
  'Hispanic/Latino',
  'East Asian',
  'South Asian',
  'Black or African American',
  'Native Hawaiian or Other Pacific Islander',
  'White',
  'Two or More Races',
  'No Response',
];

// export const regionList = ['West', 'East', 'Midwest', 'Southeast', 'Northeast'];

export const fieldOfStudyList = [
  'No formal education',
  'Vocational qualification',
  'Associate\'s degree',
  'Bachelor\'s degree',
  'Master\'s degree',
  'Doctorate or higher',
];

export const employmentStatusList = [
  'Full time',
  'Part time',
  'Unemployed',
  'Self-Employed',
  'Retired',
];

export const experienceYearsList = [
  '1-3',
  '4-6',
  '7-9',
  '10-14',
  '15-19',
  '20+',
];

export const orgSeniorityList = [
  'Manager Level/Sergant',
  'Director Level/Back-Up',
  'VP/Captain',
  'Executive/Leader/Commander',
  'CEO/Chief/General',
  'Freelancer',
  'Founder',
];

export const professionStandingList = [
  'Emerging Talent',
  'Proven Professional',
  'Established Expert',
  'Industry Authority',
  'Industry Pioneer/Traiblazer',
];

export const monetizationList = ['0%', '50%', '100%'];

export const awardsList = [
  'Local/Regional Award',
  'General Industry Recognition',
  'National Award',
  'Highest Industry Award',
  'Government Honor',
];

export const pressCoverageList = [
  'Local',
  'Regional',
  'National',
  'International',
];

export const camerasList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

export const emailRatingList = ['1', '2', '3', '4', '5'];

export const eventPercentageList = ['0', '25', '50', '75', '100'];

export interface IKeyPoint {
  userId?: number;
  keyPoint: string;
}

export interface IExpertise {
  userId?: number;
  expertise: string;
}

export interface ISingleProfession {
  id: number;
  name: string;
  order?: number;
}

export interface ISingleSubProfession {
  id: number;
  name: string;
  professionId?: number;
  ProfessionId?: number;
  order?: number;
}

// Area of Focus (sub-sub-profession). Scoped to the L1 profession, not the
// sub-profession, so it carries professionId rather than subProfessionId.
export interface ISingleSubSubProfession {
  id: number;
  name: string;
  professionId?: number;
  order?: number;
}

export interface IProfession {
  profession: ISingleProfession;
  subProfession?: ISingleSubProfession | null;
  // Optional Area of Focus, a third taxonomy level under the L1 profession.
  subSubProfession?: ISingleSubSubProfession | null;
  // Per-profession tenure (Expert IQ). startDate is required by the API on write
  // (model defaults to NOW); endDate is null when isActive ("to present").
  startDate?: string | null;
  endDate?: string | null;
  isActive?: boolean;
}

export interface IClient {
  notes: string;
  date: string;
  brand: {
    name: string;
  };
  brandId: number;
}

export interface IExpertBrand {
  brand: {
    name: string;
  };
  value: number;
}

export interface ISelectOption {
  label: string;
  value: any;
}